import http from "src/_services/httpService";

import { $BASE_URL } from "src/constants";
import { isEmpty, join, map } from "lodash";
const apiUrl = $BASE_URL + '/api';

const apiEndpoint = apiUrl + "/v1/admin-panel/merchant"
const apiMerchantEndpoint = apiUrl + "/v1/merchant-dashboard"

function merchantUrl(id) {
    return `${apiEndpoint}/${id}`;
}

const createMerchant = (merchant) => {
    return http.post(apiEndpoint, merchant);
}

const getMerchants = () => {
    return http.get(apiEndpoint);
}

const getMerchant = (merchantId) => {
    return http.get(merchantUrl(merchantId));
}

const updateMerchant = (merchantId, merchant) => {
    return http.put(merchantUrl(merchantId), merchant);
}

const deleteMerchant = (merchantId) => {
    return http.delete(merchantUrl(merchantId));
}

const resetMerchantPassword = (merchantId, credentials) => {
    const url = `${apiEndpoint}/update-password/${merchantId}`
    return http.put(url, credentials);
}

const updateMerchantPODSetting = (merchantId, targetPODSetting) => {
    const url = `${apiEndpoint}/proofOfDelivery/${merchantId}`;
    return http.put(url, { proofOfDeliveryActive: targetPODSetting });
}

const getMerchantsBySearch = (text) => {
    return http.get(`${apiUrl}/v1/admin-panel/merchant?searchKey=${text}`);
}

const getAllMerchants = () => {
    return http.get(`${apiUrl}/v1/admin-panel/merchant/search`);
}

//TODO: all search apis to follow the following design, to allow for dynamic key search and multi key search
const searchMerchants = searchParams => {
    // search params to be object with key, value pairs used in query params
    let queryString = "";
    if (!isEmpty(searchParams)) {
        queryString = join(map(searchParams, (value, key) => `${key}=${value}`), '&');
    }
    return http.get(`${apiUrl}/v1/admin-panel/merchant/search?${queryString}`);
}

const updateShippingType = (params) => {
    const url = `${apiMerchantEndpoint}/update-shipping-type`;
    return http.put(url, params);
}

const MerchantService = {
    createMerchant,
    getMerchants,
    getMerchant,
    updateMerchant,
    deleteMerchant,
    resetMerchantPassword,
    updateMerchantPODSetting,
    getMerchantsBySearch,
    getAllMerchants,
    searchMerchants,
    updateShippingType
};

export default MerchantService;

